import { StyleSheet, Text, View, ViewProps } from "react-native";

export default function DashboardBox(props:ViewProps) {
    return (
        <View style={[styles.BoxContainer, props.style]}>
            {props.children}
        </View>
    )
}

const styles = StyleSheet.create({
    BoxContainer: {
        padding: 20,
        borderRadius: 12,
        boxShadow: "0 2px 10px 0 rgba(79, 95, 216, 0.1);",
        backgroundColor: "#fff"
    }
})